/**
 *  Site disc text
 */

( function ( document ) {
  /**
     *  Main ini function
     */
  function init () {
      $('.mar').marquee({
        //duration in milliseconds of the marquee
        duration: 15000,
        //gap in pixels between the tickers
        gap: 50,
        //time in milliseconds before the marquee will start animating
        delayBeforeStart: 0,
        //'left' or 'right'
        direction: 'left',
        //true or false - should the marquee be duplicated to show an effect of continues flow
        duplicated: true,
      });
  }

  document.addEventListener( 'DOMContentLoaded', init );
}( document ));



// WEBPACK FOOTER //
// ./js/scripts/components/_site_disc.js